var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleaseHistory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.111,
    height: 11.472,
    viewBox: "0 0 13.111 11.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -32.222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.375,32.222A5.74,5.74,0,0,0,1.7,37.139H0L2.458,39.6l2.458-2.458H3.361a4.1,4.1,0,1,1,.687,3.211l-1.33.957a5.736,5.736,0,1,0,4.657-9.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.778,161.111v3.332l2.446,1.468.843-1.405-1.651-.991v-2.4Z",
    transform: "translate(-251.222 -125.611)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseHistory);
export default __webpack_public_path__ + "static/media/releaseHistory.a456872620f060c07b4d402360334529.svg";
export { ForwardRef as ReactComponent };